module.exports = __webpack_public_path__ + "static/img/AmoebaFamily.b7d9236.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/47b/images/AmoebaFamily.png
// module id = l0wr
// module chunks = 1